import { z } from "../../wire/zod";

export const createSyncSessionResponseSchema = z.object({ syncSessionId: z.string() });
export const getALMIssuesResponseSchema = z.object({
  results: z.array(
    z.object({
      issueId: z.string(),
      issueUrl: z.string(),
      summary: z.string(),
      storyPoints: z.union([z.number(), z.null()]).optional(),
      assignee: z
        .union([
          z.object({
            pipId: z
              .union([
                z.string().describe("PI planning user id, null when the user is not mapped"),
                z.null().describe("PI planning user id, null when the user is not mapped"),
              ])
              .describe("PI planning user id, null when the user is not mapped"),
            almId: z
              .union([
                z.string().describe("ALM user id, null when the user is not a mapped ALM user"),
                z.null().describe("ALM user id, null when the user is not a mapped ALM user"),
              ])
              .describe("ALM user id, null when the user is not a mapped ALM user"),
          }),
          z.null(),
        ])
        .optional(),
      issueType: z.string(),
      almTypeId: z.string(),
      sourceId: z.number().int(),
    }),
  ),
  total: z.number().int(),
  limit: z
    .number()
    .int()
    .describe(
      "Maximum number of issues that can be returned. Use to detect if results were truncated.",
    ),
  query: z
    .object({
      sections: z.array(
        z.object({
          name: z
            .string()
            .describe("Section identifier (project, issuetype, team_fields, sprint, assignee)"),
          value: z.string().describe("Query string for this section (format depends on ALM tool)"),
          isDefault: z
            .boolean()
            .describe(
              "True if from board config (default), False if user-influenced (from filters)",
            ),
        }),
      ),
      separator: z.string().describe("Separator used between sections in the full query string"),
    })
    .describe(
      "Optional query metadata. Contains structured sections of the query (format depends on ALM tool).",
    )
    .optional(),
});
export const getAlmItemTypeResponseSchema = z.object({
  almItemType: z.record(z.string(), z.any()).optional(),
});
export const getLinkTypeResponseSchema = z.object({
  linkType: z.record(z.string(), z.any()).optional(),
});
export const getLinkTypesResponseSchema = z.object({
  linkTypes: z.array(z.record(z.string(), z.any())).optional(),
});
export const getSessionInfoResponseSchema = z
  .object({
    syncSessionId: z.union([z.string(), z.null()]).optional(),
    almConnectionType: z.union([z.string(), z.null()]).optional(),
    almConnectionId: z.union([z.string(), z.null()]).optional(),
    disableDelete: z.boolean(),
  })
  .describe("All-null fields = the session has no ALM connection (a normal state, not an error)");
export const getStatusResponseSchema = z.object({
  status: z.enum(["stopped", "starting", "running", "error", "synced", "syncing"]),
});
export const iterationSyncUpdatedEventSchema = z.object({
  teamId: z.number().int(),
  piIterationId: z.number().int(),
  status: z.enum(["stopped", "starting", "running", "error", "synced", "syncing"]),
  error: z.string().optional(),
  errorAction: z.string().optional(),
});
export const noDataSchema = z.record(z.string(), z.never());
export const runningStateUpdatedEventSchema = z.object({
  status: z.enum(["stopped", "starting", "running", "error", "synced", "syncing"]),
});
